import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ResourceService', ResourceService);

  ResourceService.$inject = [
    'RestResource',
    '$translate',
    'UtilService',
    'SessionService',
    'WindowModalService',
    'ResourceModalService',
  ];

  function ResourceService(
    RestResource,
    $translate,
    UtilService,
    SessionService,
    WindowModalService,
    ResourceModalService
  ) {
    let utils = new UtilService(this);

    let apiUrl = environment.apiEndpoint + 'resources';

    let service = {
      getFilterCriteria: getFilterCriteria,
      getResources: getResources,
      getResource: getResource,
      saveResource: saveResource,
      openResourceDetailModal: openResourceDetailModal,
      changeResourceStatus: changeResourceStatus,
      deleteResource: deleteResource,
      openAddResources: openAddResources,
      openResourceCalendarModal: openResourceCalendarModal,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      const filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function getResources(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getResource(id, params) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveResource(resource) {
      resource.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'post',
        apiUrl,
        { resource: resource },
        function (response) {
          // let msg = !resource.id ? 'RESOURCE_ADDED' : 'RESOURCE_MODIFIED';
          utils._successMsg($translate.instant('RESOURCE_ADDED'));

          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function openResourceDetailModal(resource, mode, successCallback) {
      let templateUrl = './app/ajs/resources/modals/resource-detail-modal.html';

      let originalItem = angular.copy(resource);

      let modalParams = {
        title: 'RESOURCE_DETAILS',
        item: originalItem,
        mode: mode,
        preventModalClose: true,
      };

      // if (!resource.id){
      //     modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      let confirmCallback = function () {
        return successCallback();
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function changeResourceStatus(resource) {
      // utils.changeItemStatus(apiUrl +'/'+ resource.id, resource);
      // let newStatus = item.status ? false : true;

      let url = apiUrl + '/' + resource.id + '?set_status=true';

      let newStatus = !resource.status;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, resource);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function deleteResource(resource, successCallback) {
      let url = apiUrl + '/' + resource.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'REMOVE_RESOURCE',
            itemName: resource.name,
            confirmButtonLabel: 'CONFIRM',
            body: 'REMOVE_RESOURCE_MSG',
            successMsg: 'RESOURCE_REMOVED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function openAddResources(successCallback) {
      ResourceModalService.openAddResources(successCallback);
    }

    function openResourceCalendarModal(resource) {
      let templateUrl = './app/ajs/resources/modals/resource-calendar-modal.html';

      let modalParams = {
        title: 'RESOURCE_CALENDAR',
        item: resource,
        // preventModalClose: true
      };

      WindowModalService.open(templateUrl, modalParams);
    }
  }
})();
